import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authService } from "../../services/api";
import BotonGoogle from "../Auth/BotonGoogle";
import "./Login.css";

function Login() {
  const [vista, setVista] = useState("login");
  const [formulario, setFormulario] = useState({
    nombre: "",
    email: "",
    password: "",
    telefono: "",
    instagram: "",
  });
  const [error, setError] = useState("");
  const [cargando, setCargando] = useState(false);
  const [registroExitoso, setRegistroExitoso] = useState(false);
  const [emailOlvide, setEmailOlvide] = useState("");
  const [olvideEnviado, setOlvideEnviado] = useState(false);
  const [perfilIncompleto, setPerfilIncompleto] = useState(false);
  const [telefonoPerfil, setTelefonoPerfil] = useState("");
  const [instagramPerfil, setInstagramPerfil] = useState("");
  const [guardandoPerfil, setGuardandoPerfil] = useState(false);
  const navigate = useNavigate();

  const finalizarLogin = (datos) => {
    localStorage.setItem("token", datos.token);
    localStorage.setItem("nombre", datos.nombre);
    localStorage.setItem("email", datos.email);
    localStorage.setItem("esAdmin", datos.esAdmin);

    if (!datos.telefono) {
      setPerfilIncompleto(true);
    } else {
      navigate("/");
    }
  };

  const manejarCompletarPerfil = async (e) => {
    e.preventDefault();
    setGuardandoPerfil(true);
    try {
      await authService.completarPerfil(telefonoPerfil, instagramPerfil);
      navigate("/");
    } catch (error) {
      setError("No se pudo guardar tu teléfono. Podés completarlo después desde tu perfil.");
      navigate("/");
    } finally {
      setGuardandoPerfil(false);
    }
  };

  const manejarCambio = (e) => {
    const { name, value } = e.target;
    setFormulario({ ...formulario, [name]: value });
    setError("");
  };

  const manejarLogin = async (e) => {
    e.preventDefault();
    setCargando(true);
    setError("");

    try {
      const respuesta = await authService.login({
        email: formulario.email,
        password: formulario.password,
      });

      finalizarLogin(respuesta.data);
    } catch (error) {
      setError("Email o contraseña incorrectos");
    } finally {
      setCargando(false);
    }
  };

  const manejarRegistro = async (e) => {
    e.preventDefault();
    setCargando(true);
    setError("");

    try {
      await authService.registro({
        nombre: formulario.nombre,
        email: formulario.email,
        password: formulario.password,
        telefono: formulario.telefono,
        instagram: formulario.instagram,
      });

      setRegistroExitoso(true);
      setFormulario({ nombre: "", email: "", password: "", telefono: "", instagram: "" });
    } catch (error) {
      setError("Ya existe una cuenta con ese email");
    } finally {
      setCargando(false);
    }
  };

  const manejarOlvidePassword = async (e) => {
    e.preventDefault();
    setCargando(true);
    setError("");

    try {
      await authService.olvidePassword(emailOlvide);
      setOlvideEnviado(true);
    } catch (error) {
      setOlvideEnviado(true);
    } finally {
      setCargando(false);
    }
  };

  if (vista === "olvide") {
    return (
      <div className="login-pagina">
        <div className="login-fondo">
          <div className="login-circulo login-circulo-1"></div>
          <div className="login-circulo login-circulo-2"></div>
        </div>
        <div className="login-contenedor">
          <div className="login-logo" onClick={() => navigate("/")}>
            <span className="login-logo-principal">Glowroom</span>
            <span className="login-logo-secundario">MVD</span>
          </div>
          <div className="login-card">
            {olvideEnviado ? (
              <div className="login-bienvenida">
                <span className="bienvenida-icono">✉</span>
                <h2 className="bienvenida-titulo">Revisá tu email</h2>
                <p className="bienvenida-texto">
                  Si ese email está registrado, te enviamos un link para elegir una
                  contraseña nueva. Puede tardar unos minutos en llegar.
                </p>
                <button
                  className="btn-principal login-btn"
                  onClick={() => {
                    setVista("login");
                    setOlvideEnviado(false);
                    setEmailOlvide("");
                  }}
                >
                  Volver a iniciar sesión
                </button>
              </div>
            ) : (
              <>
                <h2 className="bienvenida-titulo" style={{ marginBottom: 8 }}>
                  Recuperar contraseña
                </h2>
                <p className="bienvenida-texto" style={{ marginBottom: 24 }}>
                  Ingresá tu email y te mandamos un link para elegir una nueva.
                </p>
                <form className="login-formulario" onSubmit={manejarOlvidePassword}>
                  <div className="formulario-grupo">
                    <label className="formulario-label">Email</label>
                    <input
                      type="email"
                      value={emailOlvide}
                      onChange={(e) => setEmailOlvide(e.target.value)}
                      className="formulario-input"
                      placeholder="tu@email.com"
                      required
                    />
                  </div>
                  <button
                    type="submit"
                    className="btn-principal login-btn"
                    disabled={cargando}
                  >
                    {cargando ? "Enviando..." : "Enviar link"}
                  </button>
                </form>
                <button className="login-volver" onClick={() => setVista("login")}>
                  ← Volver a iniciar sesión
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }

  if (registroExitoso) {
    return (
      <div className="login-pagina">
        <div className="login-fondo">
          <div className="login-circulo login-circulo-1"></div>
          <div className="login-circulo login-circulo-2"></div>
        </div>
        <div className="login-contenedor">
          <div className="login-card login-bienvenida">
            <span className="bienvenida-icono">✦</span>
            <h2 className="bienvenida-titulo">Bienvenida a Glowroom MVD</h2>
            <p className="bienvenida-texto">
              Tu cuenta fue creada con exito. Ahora podes iniciar sesion y
              reservar tu primer turno con nosotras.
            </p>
            <button
              className="btn-principal login-btn"
              onClick={() => {
                setRegistroExitoso(false);
                setVista("login");
              }}
            >
              Iniciar sesion
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (perfilIncompleto) {
    return (
      <div className="login-pagina">
        <div className="login-fondo">
          <div className="login-circulo login-circulo-1"></div>
          <div className="login-circulo login-circulo-2"></div>
        </div>
        <div className="login-contenedor">
          <div className="login-card">
            <h2 className="bienvenida-titulo" style={{ marginBottom: 8 }}>
              Ya casi terminamos
            </h2>
            <p className="bienvenida-texto" style={{ marginBottom: 24 }}>
              Contanos tu teléfono para poder coordinar tus turnos con vos.
            </p>

            {error && (
              <div className="login-error">
                <span>⚠</span> {error}
              </div>
            )}

            <form className="login-formulario" onSubmit={manejarCompletarPerfil}>
              <div className="formulario-grupo">
                <label className="formulario-label">Teléfono</label>
                <input
                  type="tel"
                  value={telefonoPerfil}
                  onChange={(e) => setTelefonoPerfil(e.target.value)}
                  className="formulario-input"
                  placeholder="09X XXX XXX"
                  required
                />
              </div>

              <div className="formulario-grupo">
                <label className="formulario-label">Instagram (opcional)</label>
                <input
                  type="text"
                  value={instagramPerfil}
                  onChange={(e) => setInstagramPerfil(e.target.value)}
                  className="formulario-input"
                  placeholder="@tu_usuario"
                />
              </div>

              <button
                type="submit"
                className="btn-principal login-btn"
                disabled={guardandoPerfil}
              >
                {guardandoPerfil ? "Guardando..." : "Continuar"}
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-pagina">
      <div className="login-fondo">
        <div className="login-circulo login-circulo-1"></div>
        <div className="login-circulo login-circulo-2"></div>
      </div>

      <div className="login-contenedor">
        <div className="login-logo" onClick={() => navigate("/")}>
          <span className="login-logo-principal">Glowroom</span>
          <span className="login-logo-secundario">MVD</span>
        </div>

        <div className="login-card">
          <div className="login-tabs">
            <button
              className={`login-tab ${vista === "login" ? "activo" : ""}`}
              onClick={() => setVista("login")}
            >
              Iniciar sesión
            </button>
            <button
              className={`login-tab ${vista === "registro" ? "activo" : ""}`}
              onClick={() => setVista("registro")}
            >
              Registrarse
            </button>
          </div>

          {error && (
            <div className="login-error">
              <span>⚠</span> {error}
            </div>
          )}

          {vista === "login" ? (
            <form className="login-formulario" onSubmit={manejarLogin}>
              <div className="formulario-grupo">
                <label className="formulario-label">Email</label>
                <input
                  type="email"
                  name="email"
                  value={formulario.email}
                  onChange={manejarCambio}
                  className="formulario-input"
                  placeholder="tu@email.com"
                  required
                />
              </div>

              <div className="formulario-grupo">
                <label className="formulario-label">Contraseña</label>
                <input
                  type="password"
                  name="password"
                  value={formulario.password}
                  onChange={manejarCambio}
                  className="formulario-input"
                  placeholder="••••••••"
                  required
                />
              </div>

              <button
                type="submit"
                className="btn-principal login-btn"
                disabled={cargando}
              >
                {cargando ? "Ingresando..." : "Ingresar"}
              </button>

              <button
                type="button"
                className="login-olvide-password"
                onClick={() => setVista("olvide")}
              >
                ¿Olvidaste tu contraseña?
              </button>
            </form>
          ) : (
            <form className="login-formulario" onSubmit={manejarRegistro}>
              <div className="formulario-grupo">
                <label className="formulario-label">Nombre completo</label>
                <input
                  type="text"
                  name="nombre"
                  value={formulario.nombre}
                  onChange={manejarCambio}
                  className="formulario-input"
                  placeholder="Tu nombre"
                  required
                />
              </div>

              <div className="formulario-grupo">
                <label className="formulario-label">Email</label>
                <input
                  type="email"
                  name="email"
                  value={formulario.email}
                  onChange={manejarCambio}
                  className="formulario-input"
                  placeholder="tu@email.com"
                  required
                />
              </div>

              <div className="formulario-grupo">
                <label className="formulario-label">Teléfono</label>
                <input
                  type="tel"
                  name="telefono"
                  value={formulario.telefono}
                  onChange={manejarCambio}
                  className="formulario-input"
                  placeholder="09X XXX XXX"
                />
              </div>

              <div className="formulario-grupo">
                <label className="formulario-label">Instagram (opcional)</label>
                <input
                  type="text"
                  name="instagram"
                  value={formulario.instagram}
                  onChange={manejarCambio}
                  className="formulario-input"
                  placeholder="@tu_usuario"
                />
              </div>

              <div className="formulario-grupo">
                <label className="formulario-label">Contraseña</label>
                <input
                  type="password"
                  name="password"
                  value={formulario.password}
                  onChange={manejarCambio}
                  className="formulario-input"
                  placeholder="••••••••"
                  required
                />
              </div>

              <button
                type="submit"
                className="btn-principal login-btn"
                disabled={cargando}
              >
                {cargando ? "Creando cuenta..." : "Crear cuenta"}
              </button>
            </form>
          )}

          <div className="login-separador">
            <span>o</span>
          </div>

          <BotonGoogle
            texto={vista === "registro" ? "signup_with" : "signin_with"}
            onExito={(datos) => finalizarLogin(datos)}
            onError={() =>
              setError("No se pudo ingresar con Google. Intentá de nuevo.")
            }
          />

          <button className="login-volver" onClick={() => navigate("/")}>
            ← Volver al inicio
          </button>
        </div>
      </div>
    </div>
  );
}

export default Login;